const state = {
  route: '',
  cryptext: '',
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  setRoute(state, Param) {
    state.route = Param;
  },
  setTmpId(state, Param) {
    state.tmpId = Param;
  },
  setRouteCryptext(state, cryptext) {
    state.cryptext = cryptext;
  },
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  setRoute: ({ state, commit }, Param) => commit('setRoute', Param),
  setTmpId: ({ state, commit }, Param) => commit('setTmpId', Param),
  setRouteCryptext: ({ state, commit }, cryptext) => commit('setRouteCryptext', cryptext),
};

// getters are functions
const getters = {
  /**
   * Get days
   */
  getRoute: state => state.route,
  getTmpId: state => state.tmpId,
  getRouteCryptext: state => state.cryptext,
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/route-data.js